'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const outputRange = [7, 98];

var selectors = {
  scale: new _DataSelector2.default('data-scale-value')
};

/**
 * @returns {Array<Object>}
 */
// import { scaleLinear } from 'd3-scale';

var getScaleValues = function getScaleValues() {
  return [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.scale.bracketed()) || [])).map(function (el) {
    return {
      el: el,
      min: parseInt(el.dataset.scaleMin),
      max: parseInt(el.dataset.scaleMax),
      value: parseInt(el.dataset[selectors.scale.key()]),
      scaledValue: null
    };
  });
};

/**
 * @param {Object} scaleObj
 * @return {Object}
 */
var setScaledValue = function setScaledValue(scaleObj) {
  var min = scaleObj.min,
      max = scaleObj.max,
      value = scaleObj.value;
  // const scale = scaleLinear()
  //   .domain([min, max])
  //   .range(outputRange);

  var scale = function scale() {
    // console.log(min, max);
  };

  scaleObj.scaledValue = Math.round(scale(value));

  return scaleObj;
};

/**
 * @param {Object} scaleObj
 */
var setScaleElementWidth = function setScaleElementWidth(scaleObj) {
  var el = scaleObj.el,
      scaledValue = scaleObj.scaledValue;


  if (!el.style.width) {
    el.style.width = scaledValue + '%';
  }
};

exports.default = {
  init: function init() {
    getScaleValues().map(setScaledValue).forEach(setScaleElementWidth);
  }
};